import { shallowEqual, useSelector } from 'react-redux';
import { getUserSettingsLoading } from '../selectors';

export const useUserSettingsLoading = () => ({
  userSettingsLoading: useSelector(getUserSettingsLoading, shallowEqual),
});
